// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uy-z","smallCardRow":"vy-z","largeCardRow":"wy-z","productSearchRow":"xy-z","curatedRow":"yy-z"};